import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from './Reveal';
import { proposals } from '../data/proposals';
export function ActionPlanSection() {
  return <section id="ruta" className="bg-white pt-14 pb-16 md:pt-16 md:pb-20" data-id="element-14" data-mp="3gizuf5nkakzc">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-[minmax(0,380px)_1fr] lg:gap-20" data-id="element-15" data-mp="3bo2nq5dr8npm">
        <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-16" data-mp="36oq0hjiz1emi">
          <Reveal data-id="element-17" data-mp="31sshf5gbpu61">
            <span aria-hidden className="flex h-1.5 w-12 overflow-hidden rounded-full" data-id="element-18" data-mp="31tam8qh1xgpk">
              <span className="w-6 bg-accent-gold" data-id="element-19" data-mp="2xpcpgmf78hzo" />
              <span className="w-3 bg-primary" data-id="element-20" data-mp="2sr1axydyljb4" />
              <span className="w-3 bg-secondary-maroon" data-id="element-21" data-mp="2srug4ux9s0r5" />
            </span>
            <h2 className="type-h2 mt-4 text-primary" data-id="element-22" data-mp="2nsrku273d8wd">
              Ruta de <span className="text-accent-gold" data-id="element-23" data-mp="qzoapmmxrzle">acción</span>
            </h2>
            <p className="type-lead mt-4 border-l-4 border-accent-gold pl-4 text-primary" data-id="element-24" data-mp="qxlnfad64kkd">
              Período <span className="text-secondary-maroon" data-id="element-25" data-mp="lyih7mlgc8at">2027 – 2030</span>
            </p>
            <p className="mt-4 text-base leading-relaxed text-foreground/70 md:text-lg" data-id="element-26" data-mp="25bsx572y1mp7">
              Diez propuestas para una Cámara de Comercio más conectada con las necesidades de las empresas, que
              fortalezca capacidades y acompañe los cambios que exige la competitividad regional.
            </p>
          </Reveal>
          <Reveal delay={0.15} className="mt-8" data-id="element-27" data-mp="2o3vd0g7rgyye">
            <div className="flex items-center gap-5 rounded-3xl bg-accent-gold p-6 md:p-7" data-id="element-28" data-mp="2o56g0dtdu2og">
              <span className="font-display text-8xl font-extrabold leading-[0.8] text-primary md:text-9xl" data-id="element-29" data-mp="2t1wzlb4ebgem">10</span>
              <p className="text-lg font-bold leading-snug text-[#2A2104]" data-id="element-30" data-mp="2ediusunf5hvf">
                propuestas concretas para impulsar a las empresas de Cali y el Valle.
              </p>
            </div>
          </Reveal>
        </div>

        <ol className="grid gap-4 sm:grid-cols-2" data-id="element-31" data-mp="370wkc7osfb5i">
          {proposals.map((p, i) => <Reveal key={p.number} delay={i % 2 * 0.08} data-id="element-32" data-mp="3bvivc9qyj1p2" data-mpi={i}>
              <motion.li whileHover={{
            y: -4
          }} transition={{
            type: 'spring',
            stiffness: 320,
            damping: 24
          }} className="group flex h-full gap-5 rounded-3xl border border-primary/10 bg-white p-6 transition-colors hover:border-primary/25 hover:bg-[#F8FAFD]" data-id="element-33" data-mp="3lo3o9tfuv8uw">
                <div className="flex flex-col items-center gap-3" data-id="element-34" data-mp="37pdryg0v1d7l">
                  <span className="font-display flex h-11 w-11 items-center justify-center rounded-full bg-accent-gold text-base font-bold text-white" data-id="element-35" data-mp="32rm01m07tr3e">
                    {p.number}
                  </span>
                  <span className="w-px flex-1 bg-primary/10" data-id="element-36" data-mp="2t1ixov77f0se" />
                </div>
                <div data-id="element-37" data-mp="2o2ftfcz1sylh">
                  <p.icon className="h-6 w-6 text-primary transition-transform group-hover:scale-110" data-id="element-38" data-mp="2o391qidnnw5q" />
                  <h3 className="type-h5 mt-3 uppercase tracking-wide text-primary" data-id="element-39" data-mp="2jzjgo2w6vwpg">{p.title}</h3>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-foreground/70" data-id="element-40" data-mp="2f1hvncf7dnbc">{p.description}</p>
                </div>
              </motion.li>
            </Reveal>)}
        </ol>
      </div>
    </section>;
}